export default __webpack_public_path__ + "static/media/card-placeholder.3ccea8fe.svg";